import React from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';

export interface StatTileProps {
  title?: string;
  value: string | number | null | undefined;
  subtitle?: string;
  height?: number | string;
}

export const StatTile: React.FC<StatTileProps> = ({
  title,
  value,
  subtitle,
  height = 200,
}) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 3, height, borderRadius: 2, display: 'flex', flexDirection: 'column' }}>
      {title && (
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            lineHeight: 1.1,
            wordBreak: 'break-word',
          }}
        >
          {value === null || value === undefined || value === '' ? '—' : value}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default StatTile;
